<template>
  <Ani class="section app-download" ID="ani-app-download">
    <div class="wrap">
      <h2 class="font36 heading">{{ headingText }}</h2>
      <div class="store-list">
        <div
          class="store"
          @click="trackDownload(appStore.ios,'ios')"
        >
          <img class="icon" src="@/assets/images/iconSvg/bg_ios.svg" :alt="t('weather.iosDown')" />
          <div class="font16 to-link">{{ t('weather.iosDown') }}</div>
      </div>
         <div
          class="store"
          @click="trackDownload(appStore.android,'android')"    
        >
          <img class="icon" src="@/assets/images/iconSvg/bg_android.svg" :alt="t('weather.AndroidZhDown')" />
          <div class="font16 to-link">{{ t('weather.AndroidZhDown') }}</div>
        </div>
        <nuxt-link
          class="store"
          @click="findBuryKey(props.buryKey?.['other'])"
          :to="localePath('/weather/APP/otherDownload')"
        >
          <img class="icon" src="@/assets/images/iconSvg/bg_other.svg" :alt="t('weather.otherDown')" />
          <div class="font16 to-link">{{ t('weather.otherDown') }}</div>
        </nuxt-link>
      </div>
    </div>
  </Ani>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import type {DownloadApp } from '~/types'
import { appDownload } from '@/utils/utils'

import { useLocalePath } from '#imports'
const localePath = useLocalePath()
interface AppDownloadProps {
  heading?: string
  appStore?: DownloadApp
  buryKey?: {
    ios?: string
    android?: string
    other?: string
  }
}

// 当前激活的index，默认选中第一个
const activeIndex = ref<number>(-1)

// 2. 定义 Props（指定泛型确保类型提示）
const props = defineProps<AppDownloadProps>()

// 3. 初始化 i18n
const { t } = useI18n()

// 4. 计算属性：处理标题默认值（延迟执行 t 函数，避免初始化时机问题）
const headingText = computed(() => {
  return props.heading || t('weather.downWeather')
})

// 5. 封装下载处理函数（简化模板逻辑，便于维护）
const handleDownload = (platform: 'ios' | 'android') => {
  findBuryKey(props.buryKey?.[platform])
}
const trackDownload = (downloadInfo: any, platform: 'ios' | 'android') => {
  findBuryKey(props.buryKey?.[platform])
  appDownload(downloadInfo.link, downloadInfo.packageUrl, downloadInfo.type)
}
</script>

<style lang="scss" scoped>
.app-download {
  text-align: center;
  background-color: #182134;
  .store-list {
    display: flex;
    justify-content: center;
    // align-items: center;
    margin-top: var(--section_padding);
    column-gap: 60px;
    .store {
      cursor: pointer;
      max-width: 120px;
      transition: all 0.3s;
      .icon {
        aspect-ratio: 1/1;
        width: 120px;
        max-width: 1.2rem;
        transition: all 0.3s;
        transform: scale(1);
      }
      .to-link {
        margin-top: 11px;
        color: var(--org-color);
        display: block;
      }
      position: relative;
      &:hover {
        .icon{
          transform: scale(1.04);
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .app-download {
    .store-list {
      column-gap: 0.4rem;
    }
  }
}
</style>
